let NibaraInstance = (function (global) {

  let nTools = {};
  let mainWindow = global;
  global.ajaxQueue = Voonto.$({});

  nTools.getStaticNode = function (url) {
    if (window.location.href.match('docker') !== null) {
      return url;
    }
    const nodes = {
      0: "static",
      1: "static1",
      2: "static2",
      3: "static3",
      4: "static4"
    };
    let mod = url.length % 5;
    if (url.match('static.abc.es')) {
      url = url.replace('static', nodes[mod]);
      Logger.info('static host modified: ' + url);
    }
    return url;
  };

  /**
   * Para Mejorar las Depuraciones y Ver los Valores de las Variables mas Facilmente se agrega el objeto dbDebug
   * Agrega funciones init, addData(jsonObject), getData() => jsonObject
   * @type {{init: window.dbDebug.init, addData: window.dbDebug.addData, getData: window.dbDebug.getData}}
   */
  nTools.dbDebug = {
    init: function () {
      localStorage.setItem("dbDebug", '');
      Logger.info('[dbDebug] init: ');
    },
    addData: function (obj) {
      let dbData = this.getData();
      if (dbData != null && dbData.length > 0) {
        dbData.push(obj);
      } else {
        dbData = [obj];
      }
      localStorage.setItem("dbDebug", JSON.stringify(dbData));
      Logger.info('[dbDebug] New data: ', obj);
      Logger.info('[dbDebug] Save data: ', dbData);
    },
    getData: function () {
      let data = localStorage.getItem("dbDebug");
      //Logger.info('LocalStorage dbDebug get', data);
      if (data != null && data.length > 0) {
        data = JSON.parse(data);
      }
      return data;
    }
  };

  nTools.cleanerUrl = function (url, marks = true, parameters = true) {
    if (marks) { //clean marcas de tags o tracking
      url = url.replace(/#\w+/g, '');
    }
    if (parameters) {
      url = url.replace(/\?.*/g, '');
    }
    return url;
  };

  nTools.getUrlParams = function () {

    let params = {};
    let queryParams = mainWindow.location.search.length > 0 ? mainWindow.location.search.substr(1).split('&') : '';
    let queryHash = mainWindow.location.hash.length > 0 ? mainWindow.location.hash.substr(1).split('&') : '';

    let queryVars = {};
    for (let i = 0; i < queryParams.length; i++) {
      let hash = queryParams[i].split('=');

      if (hash.length > 1) {
        queryVars[hash[0]] = hash[1];
      } else {
        queryVars[hash[0]] = null;
      }
    }
    params.queryParams = queryVars;

    let hashVars = {};
    for (let i = 0; i < queryHash.length; i++) {
      let hash = queryHash[i].split('=');

      if (hash.length > 1) {
        hashVars[hash[0]] = hash[1];
      } else {
        hashVars[hash[0]] = null;
      }
    }
    params.queryHash = hashVars;

    return params;
  };


  nTools.ajaxQueue = function (ajaxOpts) {
    let jqXHR,
      dfd = Voonto.$.Deferred(),
      promise = dfd.promise();

    // queue our ajax request
    ajaxQueue.queue(doRequest);

    // add the abort method
    promise.abort = function (statusText) {

      // proxy abort to the jqXHR if it is active
      if (jqXHR) {
        return jqXHR.abort(statusText);
      }

      // if there wasn't already a jqXHR we need to remove from queue
      let queue = ajaxQueue.queue(),
        index = Voonto.$.inArray(doRequest, queue);

      if (index > -1) {
        queue.splice(index, 1);
      }

      // and then reject the deferred
      dfd.rejectWith(ajaxOpts.context || ajaxOpts, [promise, statusText, ""]);
      return promise;
    };

    // run the actual query
    function doRequest(next) {
      jqXHR = Voonto.$.ajax(ajaxOpts)
        .done(dfd.resolve)
        .fail(dfd.reject)
        .then(next, next);
    }

    return promise;
  };

  return {
    nTools: nTools
  }

}(window));

window.nibara = NibaraInstance;



// WEBPACK FOOTER //
// ./src/nibara.js